import { useNavigate } from 'react-router-dom';
import { Clock, CreditCard, ArrowRight, LogOut, BellRing, QrCode, Infinity as InfinityIcon } from 'lucide-react';
import { detectCurrency } from '../lib/currency';
import { isIOS } from '../lib/socialAuth';
import { getUser, removeToken } from '../lib/auth';

export default function TrialExpiredPage() {
  const navigate = useNavigate();
  const user = getUser();
  const isAdmin = user?.role === 'admin';
  const handleLogout = () => {
    removeToken();
    navigate('/login', { replace: true });
  };
  const startsAt = detectCurrency() === 'usd' ? '$9.99/month' : (detectCurrency() === 'eur' ? '€8.99/month' : '£7.99/month');

  const features = [
    { icon: BellRing,     text: 'Team alerts from checkout to ready' },
    { icon: QrCode,       text: 'Guests check out with a QR code or link' },
    { icon: InfinityIcon, text: 'Unlimited QR code scans' },
  ];
  const iconClass = ['tx-ico--blue', 'tx-ico--teal', 'tx-ico--green'];

  return (
    <div className="tx-page">
      <div className="tx-glow" />

      <div className="tx-wrap">
        {/* Hero icon */}
        <div className="tx-hero">
          <span className="tx-hero__ring" />
          <Clock size={44} className="tx-hero__icon" />
        </div>

        {/* Title */}
        <h1 className="tx-title">
          {isAdmin ? 'Your Trial Has Ended' : 'Subscription Expired'}
        </h1>

        {/* Subtitle */}
        <p className="tx-sub">
          {isAdmin
            ? 'We hope you enjoyed exploring GuestCheckout! To continue managing your property checkouts, please choose a plan that works for you.'
            : "Access to GuestCheckout has ended for your organisation. Please contact your administrator to renew the subscription and restore access."}
        </p>

        {/* Features — admin only */}
        {isAdmin && (
          <div className="tx-list">
            {features.map((feature, index) => (
              <div key={index} className="tx-row">
                <div className={`tx-ico ${iconClass[index] || 'tx-ico--blue'}`}>
                  <feature.icon size={22} />
                </div>
                <span className="tx-row__t">{feature.text}</span>
              </div>
            ))}
          </div>
        )}

        {/* CTA — admin: choose a plan; non-admin: contact administrator + log out */}
        {!isAdmin ? (
          <button
            onClick={handleLogout}
            className="tx-cta tx-cta--ghost"
            data-testid="logout-expired-button"
          >
            <LogOut size={20} />
            Log Out
          </button>
        ) : isIOS() ? (
          <button
            onClick={() => navigate('/pricing')}
            className="tx-cta"
            data-testid="choose-plan-button-ios"
          >
            <CreditCard size={22} />
            Choose a Plan
            <ArrowRight size={22} />
          </button>
        ) : (
          <>
            <button
              onClick={() => navigate('/pricing')}
              className="tx-cta"
              data-testid="choose-plan-button"
            >
              <CreditCard size={22} />
              Choose a Plan
              <ArrowRight size={22} />
            </button>
            <p className="tx-note">
              Plans start at just <strong>{startsAt}</strong>. Cancel anytime.
            </p>
          </>
        )}

        {/* Support link */}
        <p className="tx-help">
          Questions?{' '}
          <button
            onClick={() => navigate('/contact')}
            className="tx-help__link"
            style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer' }}
          >
            Contact our support team
          </button>
        </p>

        {/* Logo */}
        <div className="tx-logo">
          <img src="/logo-new.png" alt="GuestCheckout" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      </div>
    </div>
  );
}
